/* CreateEditCommandRenderer.js */

"use strict";
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const TextControl = uiCore.Control.Textfield.InputText;
const ButtonControl = uiCore.Control.Action.Button;
const ComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;
const InputRadioControl = uiCore.Control.OptionSelection.Single.InputRadio;
const TextAreaControl = uiCore.Control.Textfield.Textarea;
const PickList = require("@gluenetworks/picklist").PickList;
const CheckboxControl = uiCore.Control.Boolean.InputCheckbox;
const AdvancedFilter = require("@gluenetworks/entity_grid_gl").AdvancedFilter;
const MODAL_TITLE = "Add / Edit Capture Command Set";
class CreateEditCommandRenderer {
    constructor(model) {
        /**
         * @type {AddLicenseComponent}
         */
        this._model = model;
        this._rootElem = this._createRootElement();
        this._rootElemContainer = document.createElement("div");
        this._rootElemContainer.classList.add("container");
        this._rootElem.appendChild(this._rootElemContainer);

        this._enabledCheckBox = new CheckboxControl({
            label: "Enabled",
            labelShown: true,
            value: false,
            darkTheme: true,
        });

        this._standardCheckBox = new CheckboxControl({
            label: "Run Gluware standard commands",
            labelShown: true,
            value: false,
            darkTheme: true,
        });

        this._name = new TextControl({
            darkTheme: true,
            readOnly: false,
        });
        this._vendor = new ComboBoxControl({
            showFilter: true,
            adjustWidth: true,
            darkTheme: true,
        });
        this._os = new ComboBoxControl({
            showFilter: true,
            adjustWidth: true,
            darkTheme: true,
        });
        this._type = new ComboBoxControl({
            showFilter: false,
            adjustWidth: true,
            darkTheme: true,
        });
        this._captureTypeRadio = new InputRadioControl({
            darkTheme: true,
            horizontal: true,
            options: [
                {
                    label: "CLI Commands",
                    value: "cli",
                },
                {
                    label: "REST API",
                    value: "rest",
                },
            ],
        });
        this._showCommand = new TextAreaControl({
            darkTheme: true,
        });
        this._conceptItems = new PickList({
            optionsLabel: "Available",
            selectedLabel: "Selected",
        });
        // REST API : Start
        this._rsiList = new PickList({
            optionsLabel: "Available",
            selectedLabel: "Selected",
        });

        this._redactionExpressionsList = new PickList({
            optionsLabel: "Available",
            selectedLabel: "Selected",
        });

        this._restURLs = new TextAreaControl({
            darkTheme: true,
        });
        // REST API : END
        this._restAPIContainer = undefined;
        this._cliContainer = undefined;
        this._errMsg = document.createElement("error-elem");
        this._saveButton = new ButtonControl({
            label: "Save",
            darkTheme: true,
            disabled: true,
            active: true,
        });
        this._cancelButton = new ButtonControl({id: "cancel", label: "Cancel", disabled: false});
        this.filteredConceptItems = [];
        this._initializeAdvancedFilterItems();
        this._registerListeners();
        this.render();
    }

    _initializeAdvancedFilterItems() {
        this._advancedFilter = undefined;
        const DEVICE_ENVIRONMENTS = {
            PRODUCTION: "Production",
            TEST: "Test",
            "PRODUCTION-TEST": "Production/Test",
        };
        const optionMapSitePaths = this._model._sitePaths.map(({id, path}) => ({
            [id]: path,
        }));
        optionMapSitePaths.unshift({null: "/"});

        const typeBaseMap = this._model._typeBaseMap;

        const optionMapDeviceTypes = [];
        _.sortBy(Object.keys(typeBaseMap)).map(function (key) {
            optionMapDeviceTypes.push({[typeBaseMap[key]]: typeBaseMap[key]});
        });

        this._filterOptions = [
            {
                id: "environment",
                field: "environment",
                name: "environment",
                label: "Environment",
                dataType: "enum",
                options: DEVICE_ENVIRONMENTS,
            },
            {
                id: "detectedHostName",
                field: "detectedHostName",
                label: "Hostname",
                dataType: "string",
                name: "detectedHostName",
            },
            {
                id: "ip",
                field: "ip",
                label: "IP Address",
                path: "connectionInformation.ip",
                dataType: "string",
                name: "ip",
            },
            {
                id: "name",
                field: "name",
                label: "Name",
                name: "name",
                dataType: "string",
            },
            {
                id: "detectedSoftwareVersion",
                field: "detectedSoftwareVersion",
                label: "OS Version",
                dataType: "string",
                name: "detectedSoftwareVersion",
            },
            {
                id: "siteCodeName",
                field: "siteCodeName",
                label: "Site Code",
                dataType: "string",
                name: "siteCodeName",
            },
            {
                id: "siteName",
                field: "siteName",
                name: "siteName",
                label: "Site Name",
                dataType: "string",
            },
            {
                id: "sitePath",
                field: "sitePath",
                name: "sitePath",
                label: "Site Path",
                dataType: "string",
            },
            {
                name: "siteId",
                field: "siteId",
                id: "siteId",
                label: "Site Path List",
                dataType: "pathlist",
                options: optionMapSitePaths,
            },
            {
                id: "siteLocationType",
                field: "siteLocationType",
                name: "siteLocationType",
                label: "Site Type",
                dataType: "enum",
                options: Object.entries(this._model._SiteEntityClass.getLocationTypeLabels()).map(
                    ([value, title]) => ({name: value, title})
                ),
            },
            {
                id: "detectedSku",
                field: "detectedSku",
                name: "detectedSku",
                label: "SKU",
                dataType: "string",
            },
            {
                id: "detectedTypeBase",
                field: "detectedTypeBase",
                name: "detectedTypeBase",
                label: "Type",
                dataType: "enum",
                options: optionMapDeviceTypes,
            },
            {
                id: "detectedUptime",
                field: "detectedUptime",
                name: "detectedUptime",
                label: "Uptime (Days)",
                dataType: "string",
            },
        ];

        this.advancedFilterContainer = document.createElement("advanced-filter-container");
    }

    get rootElement() {
        return this.getRootElement();
    }

    get model() {
        return this.getModel();
    }

    /*******************************************/
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    render() {
        if (this._renderProm === null) {
            return Promise.resolve();
        }
        this._renderProm = this._renderProm || this._render();
        return this._renderProm;
    }

    shutdown() {
        if (this._shutdownProm === null) {
            return Promise.resolve();
        }
        this._shutdownProm = this._shutdownProm || this._shutdown();
        return this._shutdownProm;
    }

    getRootElement() {
        return this._rootElem;
    }

    getModel() {
        return this._model;
    }

    /********************************************/
    /* END PUBLIC COMPONENT RENDERER METHODS    */
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._saveButton.addListener(
            "UserClick",
            (this._saveAndClosePopUp = this._saveAndClosePopUp.bind(this))
        );
        this._cancelButton.addListener(
            "UserClick",
            (this._closePopUp = this._closePopUp.bind(this))
        );
        this._vendor.on("UserValue", (this._updateVendor = this._updateVendor.bind(this)));
        this._os.on(
            "UserValue",
            (this._osChangeAndUpdateEntity = this._osChangeAndUpdateEntity.bind(this))
        );
        this._type.on("UserValue", (this._updateType = this._updateType.bind(this)));
        this._name.on("UserValue", (this._updateEntity = this._updateEntity.bind(this)));
        this._showCommand.on("UserValue", (this._updateEntity = this._updateEntity.bind(this)));
        this._conceptItems.on("Value", (this._updateEntity = this._updateEntity.bind(this)));
        this._captureTypeRadio.on(
            "Value",
            (this._captureTypeChange = this._captureTypeChange.bind(this))
        );
        this._rsiList.on("Value", (this._updateEntity = this._updateEntity.bind(this)));
        this._restURLs.on("UserValue", (this._updateEntity = this._updateEntity.bind(this)));
        this._redactionExpressionsList.on(
            "Value",
            (this._redactionListChanged = this._redactionListChanged.bind(this))
        );
        this._model.on("Error", (this._onError = this._onError.bind(this)));

        this._enabledCheckBox.on(
            "UserValue",
            (this._enableChangeAndUpdateEntity = this._enableChangeAndUpdateEntity.bind(this))
        );
        this._model.on("DisableButtons", (this._disableButtons = this._disableButtons.bind(this)));

        this._standardCheckBox.on(
            "UserValue",
            (this._standardCheckboxChange = this._standardCheckboxChange.bind(this))
        );
    }

    _registerAdvancedFilterListener() {
        this._advancedFilter.on(
            "AdvancedFilterRuleChanged",
            (this._onAdvFilterRuleChange = this._onAdvFilterRuleChange.bind(this))
        );
    }

    _unregisterListeners() {
        this._saveButton.removeListener("UserClick", this._saveAndClosePopUp);
        this._cancelButton.removeListener("UserClick", this._closePopUp);
        this._vendor.removeListener("UserValue", this._updateEntity);
        this._os.removeListener("UserValue", this._updateEntity);
        this._type.removeListener("UserValue", this._updateEntity);
        this._name.removeListener("UserValue", this._updateEntity);
        this._showCommand.removeListener("UserValue", this._updateEntity);
        this._conceptItems.removeListener("UserValue", this._updateEntity);
        this._captureTypeRadio.removeListener("UserValue", this._captureTypeChange);
        this._rsiList.removeListener("Value", this._updateEntity);
        this._restURLs.removeListener("UserValue", this._updateEntity);
        this._model.removeListener("Error", this._onError);
        this._redactionExpressionsList.removeListener("Value", this._redactionListChanged);
        this._enabledCheckBox.removeListener("UserValue", this._enableChangeAndUpdateEntity);
        this._model.removeListener("DisableButtons", this._disableButtons);
        this._standardCheckBox.removeListener("UserValue", this._standardCheckboxChange);
        this._advancedFilter.removeListener(
            "AdvancedFilterRuleChanged",
            this._onAdvFilterRuleChange
        );
    }

    _registerCopyListener(button, handler) {
        button.addListener("UserClick", handler);
        this._model.once("Shutdown", () => {
            button.removeListener("UserClick", handler);
            button.shutdown();
        });
    }

    _render() {
        return this._model.whenModelIsReady().then(() => {
            this._rootElemContainer.innerHTML = "";
            const root = document.createDocumentFragment();
            const title = document.createElement("h2");
            title.innerText = MODAL_TITLE;
            root.appendChild(title);
            root.appendChild(this._enabledCheckBox._renderer._rootElem);
            root.appendChild(this._createSection("Name", this._name));
            root.appendChild(this._createSection("Vendor", this._vendor));
            root.appendChild(this._createSection("OS", this._os));
            root.appendChild(this._createSection("Type", this._type));

            root.appendChild(this.createAdvancedFilterSection());

            root.appendChild(this.createCaptureSection());
            root.appendChild(this.createRedactionExpressions());
            root.appendChild(this._errMsg);
            this._setValues();

            return new Promise((resolve /*,reject*/) => {
                this._rootElemContainer.appendChild(root);

                // Advanced Filter
                const deviceFilter =
                    this._model._commandSetEntityInst.pristineProperties.deviceFilter;
                if (!_.isEmpty(deviceFilter)) {
                    this.sectionDeviceFilter.classList.add("expanded");

                    this._advancedFilter._renderer.$builderContainer.queryBuilder(
                        "setRulesFromMongo",
                        deviceFilter
                    );
                }

                this._registerAdvancedFilterListener();

                this._rootElem.appendChild(this._createActionsContainer());
                this._enableDisableSaveButton();

                this._name.focus();

                resolve();
            });
        });
    }

    _setValues() {
        // Enabled
        this._enabledCheckBox.setValue(this._model._commandSetEntityInst.getEnabled());
        this.setEnabledDisabled(this._model._commandSetEntityInst.getEnabled());

        // Name
        this._name.setValue(this._model._commandSetEntityInst.getName());

        // Vendor
        const vendorDropdownValues = [];
        Object.keys(this._model._vendorMap).forEach((key) => {
            vendorDropdownValues.push({label: this._model._vendorMap[key], value: key});
        });

        this._vendor.setOptions(vendorDropdownValues);
        const vendor =
            this._model._commandSetEntityInst.getVendor() ||
            _.get(this._vendor.getOptions(), "[0].value", null);
        this._vendor.setValue(vendor);

        // OS
        this._os.setOptions(this._model._filterOs(vendor) || []);
        this._os.setValue(
            this._model._commandSetEntityInst.getOs() ||
                _.get(this._os.getOptions(), "[0].value", null)
        );

        // Type

        // To be changed at platform level
        // const typeLabels = this._model._commandSetEntityDef.getDataTypeLabels();
        // const typeValues = this._model._commandSetEntityDef.getDataTypeValues();
        // const typeDropdownValues = Object.keys(typeValues).map((item) => ({
        //     label: typeLabels[item],
        //     value: item,
        // }));

        const typeDropdownValues = [
            {
                label: "Configuration",
                value: "DRIFT_AND_AUDIT",
            },
            {
                label: "Operational",
                value: "AUDIT_ONLY",
            },
        ];

        this._type.setOptions(typeDropdownValues);
        this._type.setValue(
            this._model._commandSetEntityInst.getDataType() ||
                _.get(this._type.getOptions(), "[0].value", null)
        );

        // Standard
        // If this is a new commandSet, basicMode is set to true by default
        if (!this._model._commandSetEntityInst.getId()) {
            this._model._commandSetEntityInst.pristineProperties.basicMode = true;
        }
        // basicMode value is then updated by _enableDisableStandard
        this._enableDisableStandard();

        // Redaction Expressions
        this._redactionExpressionsList.setValue(this._model._selectedRedactions || [], true);

        // Commands
        const commands = this._model._commandSetEntityInst.getCommands() || [];
        this._showCommand.setValue(_.join(commands, "\n") || "");

        // Concept Items
        this._filterConceptItems(this._os.getValue());
        const conceptItemIds = this._model._commandSetEntityInst.getConceptItemIds() || [];
        this._conceptItems.setValue(conceptItemIds, false);

        // RSI List
        const rsiIds = this._model._commandSetEntityInst.getRsiIds() || [];
        this._filterRsiList(this._os.getValue());
        this._rsiList.setValue(rsiIds, false);

        // URLs
        const urls = this._model._commandSetEntityInst.getGetUrls() || [];
        this._restURLs.setValue(_.join(urls, "\n") || "", false);

        // Capture Type
        if (_.isEmpty(rsiIds) && _.isEmpty(urls)) {
            this._captureTypeRadio.setValue("cli", false);
        } else {
            this._captureTypeRadio.setValue("rest", false);
        }
    }

    _enableDisableStandard() {
        const pristineProperties = this._model._commandSetEntityInst.getPristineProperties();

        // Enabling or disabling the checkbox
        if (this._type.getValue() === "DRIFT_AND_AUDIT") {
            if (this._model._parentView._basicOSList.indexOf(this._os.getValue()) > -1) {
                if (this._os.getValue() === pristineProperties.os && pristineProperties.basicMode) {
                    this._standardCheckBox.setDisabled(false);
                } else {
                    this._standardCheckBox.setDisabled(true);
                }
            } else {
                this._standardCheckBox.setDisabled(false);
            }
        } else {
            this._standardCheckBox.setDisabled(true);
        }

        // Setting up the checkbox value based on enabled/disabled state
        if (this._standardCheckBox.isDisabled()) {
            this._standardCheckBox.setValue(false);
        } else {
            if (this._os.getValue() === pristineProperties.os) {
                this._standardCheckBox.setValue(pristineProperties.basicMode);
            } else {
                this._standardCheckBox.setValue(true);
            }
        }

        // Update the root basicMode property
        this._model._commandSetEntityInst.setBasicMode(this._standardCheckBox.getValue());
    }

    _shutdown() {
        this._unregisterListeners();
        this._rootElem.remove();
        this._rootElem = null;
        return Promise.all([this._saveButton.shutdown(), this._cancelButton.shutdown()])
            .then(() => {
                this._model = null;
                this._shutdownProm = null;
                this._renderProm = null;
            })
            .catch((error) => {
                console.log(`${this.constructor.name}: error in shutdown`);
                console.error(error);
            });
    }

    /********************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS   */
    /* START PRIVATE RENDERER METHODS           */
    /********************************************/

    _createRootElement() {
        const rootElement = document.createElement("div");
        rootElement.classList.add("create-edit-commands", "modal_feedback_container");
        rootElement.component = this._model;
        return rootElement;
    }

    _createSection(name, Component) {
        const section = document.createElement("section");
        const label = document.createElement("label");
        section.className = "key-section";
        label.innerText = name;
        Component.setAttribute("rows", "6");
        section.appendChild(label);
        section.appendChild(Component.renderer.rootElement);
        return section;
    }

    _createBlockSection(content, options = {}) {
        const section = document.createElement("section");

        section.className = options.className || "";

        section.classList.toggle("bordered", !!options.bordered);
        if (options.title) {
            const title = document.createElement("h2");
            title.innerText = options.title;
            section.appendChild(title);
        }

        if (options.className && options.className === "expandable") {
            const expandButton = document.createElement("span");
            expandButton.classList.add("expand-btn");
            section.appendChild(expandButton);

            expandButton.addEventListener("click", () => {
                section.classList.toggle("expanded");
            });
        }

        section.appendChild(content);

        if (!_.isEmpty(options.createObject)) {
            this[options.createObject] = section;
        }

        return section;
    }

    _createActionsContainer() {
        const container = document.createElement("section");
        container.className = "actions-container";
        container.appendChild(this._cancelButton.renderer.rootElement);
        container.appendChild(this._saveButton.renderer.rootElement);
        return container;
    }

    createAdvancedFilterSection() {
        this._advancedFilterContainer = document.createElement("advanced-filter-container");

        this._createAdvancedFilter(this._advancedFilterContainer);

        return this._createBlockSection(this._advancedFilterContainer, {
            title: "Device Filter",
            bordered: true,
            className: "expandable",
            createObject: "sectionDeviceFilter",
        });
    }

    _createAdvancedFilter(filterContainer) {
        const customFieldsList = [];

        for (let field in this._model._customFieldsWithInherited) {
            if (
                this._model._customFieldsWithInherited.hasOwnProperty(field) &&
                !this._model._customFieldsWithInherited[field].systemOwned &&
                ["Boolean", "String", "Enum", "Dropdown"].indexOf(
                    this._model._customFieldsWithInherited[field].dataType
                ) >= 0
            ) {
                customFieldsList.push(
                    Object.assign({}, this._model._customFieldsWithInherited[field], {
                        id: field,
                        name: `customFieldValues.${field}`,
                        label: this._model._customFieldsWithInherited[field].name,
                    })
                );
            }
        }

        this._advancedFilter = new AdvancedFilter({
            filterData: {},
            columnsConfig: this._getFilterOptions(this._filterOptions, customFieldsList),
            allowGroups: 1,
        });

        filterContainer.appendChild(this._advancedFilter.getRootElement());
    }

    _getFilterOptions(columnsData, customFields) {
        const filterOptions = [].concat(columnsData, customFields);
        const allowedCustomFieldTypes = ["boolean", "string", "enum", "pathlist"];
        return filterOptions
            .filter((option) => {
                if (
                    option.dataType &&
                    !allowedCustomFieldTypes.includes(option.dataType.toLowerCase())
                ) {
                    return false;
                }
                return true;
            })
            .map((optData) => {
                const options = {
                    dataType: optData.dataType ? optData.dataType.toLowerCase() : undefined,
                };
                return Object.assign({}, optData, options);
            });
    }

    createCaptureSection() {
        this._captureContainer = document.createElement("capture-container");

        this._captureContainer.appendChild(this._captureTypeRadio._renderer._rootElem);
        this._captureContainer.appendChild(this._standardCheckBox._renderer._rootElem);
        return this._createBlockSection(this._captureContainer, {
            title: "Capture Commands",
            bordered: true,
        });
    }

    createRedactionExpressions() {
        this._redactionExContainer = document.createElement("redaction-expressions-container");
        this._redactionExContainer.appendChild(this._redactionExpressionsList._renderer._rootElem);
        this._redactionExpressionsList.setOptions(this._model._redactionExpItemsForPickList || []);
        return this._createBlockSection(this._redactionExContainer, {
            title: "Redaction Expressions",
            bordered: true,
        });
    }

    _captureTypeChange(e) {
        if (e === "cli") {
            if (!this._cliContainer) {
                this._captureContainer.appendChild(this._renderCliCommands());
            }
            this._cliContainer.classList.remove("hidden");
            if (this._restAPIContainer) {
                this._restAPIContainer.classList.add("hidden");
            }
        } else {
            if (!this._restAPIContainer) {
                this._captureContainer.appendChild(this._renderRestAPI());
            }
            this._restAPIContainer.classList.remove("hidden");
            if (this._cliContainer) {
                this._cliContainer.classList.add("hidden");
            }
        }
        this._updateEntity();
    }

    _renderCliCommands() {
        this._cliContainer = document.createElement("cli-container");

        this._cliContainer.appendChild(this._createSection("CLI Commands", this._showCommand));
        // this._conceptItems.setOptions(this._model._conceptItemsForPickList);
        // this._conceptItems.setSelectedOptions
        this._cliContainer.appendChild(this._createSection("Concept Items", this._conceptItems));
        return this._cliContainer;
    }

    _renderRestAPI() {
        this._restAPIContainer = document.createElement("rest-api-container");
        // this._restAPIContainer.appendChild(this._createSection("Section", this._section));
        this._restAPIContainer.appendChild(this._createSection("RSI List", this._rsiList));
        // this._rsiList.setOptions(this._model._rsiItemsForPickList);
        this._restAPIContainer.appendChild(this._createSection("GET Requests", this._restURLs));
        return this._restAPIContainer;
    }

    /********************************************/
    /* END PRIVATE RENDERER METHODS             */
    /* START HANDLER METHODS                    */
    /********************************************/

    _saveAndClosePopUp() {
        // const objResult = {
        //     vendor: this._vendor.getValue(),
        //     os: this._os.getValue(),
        //     type: this._type.getValue(),
        //     name: this._name.getValue(),
        //     captureType: this._captureTypeRadio.getValue()
        // };
        // if(this._captureTypeRadio.getValue() === 'cli') {
        //     Object.assign(objResult, {
        //         cliCommands: this._showCommand.getValue(),
        //         conceptItems: this._conceptItems.getValue()
        //     })
        // }
        if (this._saveButton.getLabel() === "Force Save") {
            return this._model.saveAndClosePopUp(true);
        }
        return this._model.saveAndClosePopUp(false);
    }

    _closePopUp() {
        // this._model
        return this._model.closePopUp();
    }

    _updateVendor(vendor) {
        const osMapDropdownValues = this._model._filterOs(vendor);
        this._os.setOptions(osMapDropdownValues);
        const osName = _.get(this._os.getOptions(), "[0].value", null);
        this._os.setValue(osName);
        this._filterConceptItems(osName);
        this._filterRsiList(osName);
        this._updateEntity();
        this._enableDisableStandard();
    }

    _updateType() {
        this._updateEntity();
        this._enableDisableStandard();
    }

    _updateEntity(newVal, oldVal, triggeredByUser = true) {
        if (triggeredByUser) {
            this._model._commandSetEntityInst.setVendor(this._vendor.getValue() || "");
            this._model._commandSetEntityInst.setOs(this._os.getValue() || "");
            this._model._commandSetEntityInst.setDataType(this._type.getValue() || "");
            this._model._commandSetEntityInst.setName(this._name.getValue() || "");

            this._model._commandSetEntityInst.setBasicMode(
                this._standardCheckBox.getValue() || false
            );

            if (this._captureTypeRadio.getValue() === "cli") {
                // Empty the Rest API
                this._model._commandSetEntityInst.setRsiIds(undefined);
                this._model._commandSetEntityInst.setGetUrls(undefined);

                // Trim the textfield
                let commandSet = _.split(this._showCommand.getValue(), "\n");
                commandSet = commandSet
                    .map((item) => _.trim(item))
                    .filter((item) => _.trim(item) !== "");

                this._model._commandSetEntityInst.setCommands(commandSet);
                this._model._commandSetEntityInst.setConceptItemIds(
                    this._conceptItems.getValue() || []
                );
            } else if (this._captureTypeRadio.getValue() === "rest") {
                // Empty the CLI commands
                this._model._commandSetEntityInst.setCommands([]);
                this._model._commandSetEntityInst.setConceptItemIds(undefined);
                this._model._commandSetEntityInst.setRsiIds(this._rsiList.getValue() || []);
                this._model._commandSetEntityInst.setGetUrls(
                    _.trim(this._restURLs.getValue()) === ""
                        ? []
                        : _.split(this._restURLs.getValue(), "\n")
                );
            }
            this._enableDisableSaveButton();
            this._clearError();
        }
    }

    _redactionListChanged(newVal, oldVal, triggeredByUser = true) {
        if (triggeredByUser) {
            if (newVal.length > oldVal.length) {
                (this._redactionExpressionsList.getValue() || []).map((redExp) => {
                    if (this._model._selectedRedactions.indexOf(redExp) < 0) {
                        this._model._selectedRedactions.push(redExp);
                        this._model._commandSetEntityInst.addToRedactionRegexRelationship(redExp);
                    }
                });
            } else {
                _.difference(oldVal, newVal).map((redExp) => {
                    if (this._model._selectedRedactions.indexOf(redExp) > -1) {
                        this._model._selectedRedactions = this._model._selectedRedactions.filter(
                            (i) => i !== redExp
                        );
                        this._model._commandSetEntityInst.removeFromRedactionRegexRelationship(
                            redExp
                        );
                    }
                });
            }
            this._enableDisableSaveButton();
        }
    }

    _osChangeAndUpdateEntity(val) {
        this._filterConceptItems(val);
        this._filterRsiList(val);
        this._updateEntity();
        this._enableDisableStandard();
    }

    _standardCheckboxChange() {
        this._updateEntity();
    }

    _onAdvFilterRuleChange(event) {
        let filterVal;
        try {
            filterVal = event.builder.getRules({skip_empty: true, allow_invalid: true});
        } catch (error) {
            if (typeof error.message !== "string") {
                error.message = "Not of type String!!";
            }
            const errorMessagesList = [
                "Cannot read property 'each' of null".toLowerCase().replace(/['" ]/gi, ""),
                "Cannot read property 'root' of null".toLowerCase().replace(/['" ]/gi, ""),
            ];
            if (errorMessagesList.indexOf(error.message.toLowerCase().replace(/['" ]/gi, "")) < 0) {
                this._model._logger.warn({error}, "Advanced filter delete error");
            }
        }

        if (_.get(filterVal, "rules", []).length > 0) {
            if (filterVal.valid) {
                const filterValue = event.target.queryBuilder.getMongo(filterVal);
                this._model._commandSetEntityInst.setDeviceFilter(filterValue);
            }
        } else {
            this._model._commandSetEntityInst.setDeviceFilter({});
        }

        this._enableDisableSaveButton();
        this._clearError();
    }

    _filterConceptItems(val) {
        const osNameObj = this._os._options.find((i) => i.value === val);
        let osName = _.get(osNameObj, "label");

        if (osName) {
            this.filteredConceptItems = Object.values(this._model.conceptItems).reduce(
                (acc, item) => {
                    if (item.os && item.os.indexOf(osName) > -1) {
                        acc.push({label: item.label, value: item.value});
                        return acc;
                    } else {
                        return acc;
                    }
                },
                []
            );
        } else {
            this.filteredConceptItems = [];
        }

        this._conceptItems.setOptions(this.filteredConceptItems);
        this._conceptItems.setValue([], false);
    }

    _filterRsiList(val) {
        const osNameObj = this._os._options.find((i) => i.value === val);
        let osName = _.get(osNameObj, "label");

        if (osName) {
            this.filteredRsiItems = Object.values(this._model.rsiItems).reduce((acc, item) => {
                if (item.os && item.os.indexOf(osName) > -1) {
                    acc.push({label: item.label, value: item.value});
                    return acc;
                } else {
                    return acc;
                }
            }, []);
        } else {
            this.filteredRsiItems = [];
        }

        this._rsiList.setOptions(this.filteredRsiItems);
        this._rsiList.setValue([], false);
    }

    _enableDisableSaveButton() {
        if (!this._formInvalid()) {
            if (
                !_.isEmpty(this._model._commandSetEntityInst._pendingPatches) ||
                !_.isEmpty(this._model._commandSetEntityInst._pendingRelationships)
            ) {
                this._saveButton.setDisabled(false);
            } else {
                this._saveButton.setDisabled(true);
            }
        } else {
            this._saveButton.setDisabled(true);
        }
    }

    _formInvalid() {
        let isInvalid =
            _.isEmpty(this._vendor.getValue()) ||
            _.isEmpty(this._os.getValue()) ||
            _.isEmpty(this._type.getValue()) ||
            _.isEmpty(this._name.getValue());

        if (!isInvalid && this._standardCheckBox.getValue()) {
            return false;
        }

        if (this._captureTypeRadio.getValue() === "rest") {
            return (
                isInvalid ||
                (_.isEmpty(this._rsiList.getValue()) && _.isEmpty(this._restURLs.getValue()))
            );
        }

        return (
            isInvalid ||
            (_.isEmpty(this._conceptItems.getValue()) && _.isEmpty(this._showCommand.getValue()))
        );
    }

    _onError(error, forceable = false) {
        this._errMsg.innerText = error;
        if (forceable) {
            this._saveButton.setLabel("Force Save");
        }
    }

    _clearError() {
        this._errMsg.innerText = "";
        this._saveButton.setLabel("Save");
    }

    _enableChangeAndUpdateEntity(val) {
        this._model._commandSetEntityInst.setEnabled(val);
        this.setEnabledDisabled(val);
        this._enableDisableSaveButton();
        this._clearError();
    }

    setEnabledDisabled(val) {
        if (!val) {
            this._rootElem.classList.add("disabled-form");
        } else {
            this._rootElem.classList.remove("disabled-form");
        }
    }

    _disableButtons() {
        this._saveButton.setDisabled(true);
        this._cancelButton.setDisabled(true);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /*  END PUBLIC API METHODS                 */
    /*******************************************/
}
module.exports = CreateEditCommandRenderer;
